



import { Part } from '@/components/products/PartsPage'
import AttributeLabel
  from '@/components/products/product-details/attribute-label/AttributeLabel.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    AttributeLabel
  }
})
export default class PartsList extends Vue {
  @Prop() parts!: Part[]

  get headerDefs() {
    const anyPart = this.parts.find(() => true) as Part
    return Object.keys(anyPart)
  }

  values(part: Part) {
    return Object.values(part)
  }

  entries(part: Part) {
    return Object.entries(part)
  }
}
